module.exports = __webpack_public_path__ + "img/img0.3c73bd35.jpg";